import { render, staticRenderFns } from "./editCabinetDialog.vue?vue&type=template&id=b78b87b8&scoped=true"
import script from "./editCabinetDialog.vue?vue&type=script&lang=js"
export * from "./editCabinetDialog.vue?vue&type=script&lang=js"
import style0 from "./editCabinetDialog.vue?vue&type=style&index=0&id=b78b87b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78b87b8",
  null
  
)

export default component.exports